import React from 'react'
import Container from 'components/layout/Container';
import { BannerBox } from 'views/Landing/Banner/BannerStyled';
import "react-multi-carousel/lib/styles.css";
import WithdrawHeader from 'components/Header/WithdrawHeader';
import Marquee from './Marquee';
import HeadingComponent from 'components/HeadingComponent';
import { ReactComponent as TopGamesBanner } from 'assets/Hero/TopGamesBanner.svg';
import GamesCarousal from './GamesCarousal';
import { Box } from 'components/Box';


const Games: React.FC = () => {

    return (
        <>
            <WithdrawHeader />

            <Marquee />

            <Container>

                <BannerBox>
                    <a href="https://play.google.com/store/apps/details?id=com.gamesfi.cryptoshooter" target='_blank' rel="noopener noreferrer">
                        <TopGamesBanner className='BannerImg' />
                    </a>
                </BannerBox>

                <HeadingComponent>GAMES OF CHANCE</HeadingComponent>
                <Box style={{ marginBottom: "30px" }}>
                    <GamesCarousal />
                </Box>
                {/* 
                <HeadingComponent>GAMES OF SKILL</HeadingComponent>
                <Box style={{ marginBottom: "30px" }}>
                    <GamesCarousal />
                </Box> */}

            </Container>
        </>
    )
}

export default Games;